import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@/lib/i18n";

export default function PaywallModal({ open, onOpenChange, reason }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="paywall-upgrade-modal" className="sm:max-w-md">
        <DialogHeader>
          <div className="inline-flex w-10 h-10 items-center justify-center rounded-lg bg-card border border-border/70 mb-2">
            <Lock className="w-4 h-4 text-[#3182CE]" />
          </div>
          <DialogTitle className="font-display text-xl">{t("paywall.title")}</DialogTitle>
          <DialogDescription>
            {reason || t("paywall.default_reason")}
          </DialogDescription>
        </DialogHeader>
        <ul className="text-sm space-y-1.5 mt-2">
          <li className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-[#3182CE]" /> {t("paywall.bullet_unlimited")}</li>
          <li className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-[#3182CE]" /> {t("paywall.bullet_ai")}</li>
          <li className="flex items-center gap-2"><Sparkles className="w-4 h-4 text-[#3182CE]" /> {t("paywall.bullet_alerts")}</li>
        </ul>
        <DialogFooter className="sm:justify-end gap-2 mt-4">
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="paywall-close-button">{t("paywall.later")}</Button>
          <Button data-testid="paywall-upgrade-cta-button" onClick={() => { onOpenChange(false); navigate("/billing"); }}>
            {t("paywall.see_plans")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
